import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_23462_9309)\"><path d=\"M15.4165 15.4167L18.3332 18.3334\" stroke=\"currentColor\" stroke-opacity=\"0.6\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path><path d=\"M5.62484 2.7258C6.78927 2.05221 8.1412 1.66669 9.58317 1.66669C13.9554 1.66669 17.4998 5.2111 17.4998 9.58335C17.4998 13.9556 13.9554 17.5 9.58317 17.5C5.21092 17.5 1.6665 13.9556 1.6665 9.58335C1.6665 8.14138 2.05202 6.78946 2.72561 5.62502\" stroke=\"currentColor\" stroke-opacity=\"0.6\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path></g><defs><clipPath id=\"clip0_23462_9309\"><rect width=\"20\" height=\"20\" fill=\"white\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }